import React, { useState, useEffect } from 'react';
import Carousel from '../../../baseComponents/gui/carousel/Carousel';
import RulesItem from '../rulesItem/RulesItem';

const RulesCarousel = React.forwardRef(function ({ activeSlide, setActiveSlide, rulesList }, ref) {
  const [swiper, setSwiper] = useState();

  useEffect(() => {
    if (swiper) swiper.slideTo(activeSlide);
  }, [swiper, activeSlide]);

  return (
    <div className={'rules__carousel'}>
      <Carousel
        item={RulesItem}
        itemsData={rulesList}
        settings={{
          autoHeight: true,
          pagination: { el: '.rules__pagination', clickable: true },
          onSlideChange: (swiper) => setActiveSlide(swiper.activeIndex),
          onInit: (swiper) => setSwiper(swiper),
        }}
      />
      {rulesList.length > 1 && <div className={'rules__pagination'} />}
    </div>
  );
});
export default RulesCarousel;
RulesCarousel.propTypes = {};
